import editorAction from "../actions/editorAction";
import { useTreeStateContext } from "../contexts/TreeContext";
import BlockContainerAction from '../actions/blockContainerAction';
// Warning useCtrlKey is activate with shiftKey
function useShiftKey() {
    const { setShitKey } = editorAction();

    const { shiftKey } = useTreeStateContext();

    const { deleteAllSelectedBlock } = BlockContainerAction(); 
    
    const changeShiftKey = (e) => {
        //console.log('toto');
        //if(document.querySelector('.input editor-input title_input')) return;
        if(document.activeElement == null || document.activeElement.nodeName == 'TEXTAREA') return;
        if(document.activeElement.nodeName == 'INPUT' && document.activeElement.type != 'file') return;
        deleteAllSelectedBlock();
        setShitKey(!shiftKey)
        document.querySelectorAll('.block').forEach(block => !shiftKey ? block.classList.add('shiftKey') : block.classList.remove('shiftKey') || block.classList.remove('selected'))
        // Messy fix for optimize rendering on block for multiple selection
        //document.querySelectorAll('.block').forEach(block => block.classList.add('shiftKey'))
    }

    const pressShiftKey = (e) => {
        if (shiftKey) return;
        //setCtrlKey(true)
        /*
        if(e.shiftKey != shiftKey) {
            changeShiftKey();
        }*/
    }

    return { changeShiftKey, pressShiftKey, shiftKey };
}

export default useShiftKey;